import { Chip } from "@mui/material";

interface Props {
  isActive: boolean;
}

export default function YouTubeChannelStatusChip({ isActive }: Props) {
  return (
    <Chip
      label={isActive ? "Active" : "Inactive"}
      color={isActive ? "success" : "default"}
      size="small"
      variant={isActive ? "filled" : "outlined"}
    />
  );
}
